<template>
  <v-card class="card" flat width="100%">
    <v-card-text class="pa-3">
      <line-chart :chart-data="filterData" :options="chartOptions" />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: ['dataReceived'],
  components: {
    LineChart: () => import('@/components/generic/LineChart')
  },
  data() {
    return {
      data: {
        datasets: [
          {
            label: 'Puntaje Individual del Test UNI',
            data: [],
            fill: true,
            borderColor: '#3F51B5',
            pointBorderWidth: '2',
            lineTension: 1
          },

          {
            label: 'Promedio Global',
            data: [],
            fill: true,
            borderColor: '#009688',
            pointBorderWidth: '2',
            lineTension: 1
          }
        ],
        labels: []
      },

      chartOptions: {
        scales: {
          xAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Habilidades'
              }
            }
          ],
          yAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Puntaje'
              },
              ticks: {
                beginAtZero: true,
                min: 0,

                userCallback: function (label, index, labels) {
                  // when the floored value is the same as the value we have a whole number
                  if (Math.floor(label) === label) {
                    return label
                  }
                }
              }
            }
          ]
        }
      }
    }
  },

  methods: {
    ...mapActions('user', ['fetchResultadosGlobalesTest'])
  },

  computed: {
    filterData: function () {
      let tempdata = { ...this.data }
      console.log('this.dataReceived', this.dataReceived)
      this.dataReceived.alumno.forEach((item) => {
        tempdata.datasets[0].data.push(item.puntaje)
        tempdata.labels.push(item.nombre)
      })

      this.dataReceived.global.forEach((item) => {
        tempdata.datasets[1].data.push(item.puntaje)
      })

      return tempdata
    }
  },

  async mounted() {
    //await this.fetchResultadosGlobalesTest();
    //console.log("dataReceived", this.dataReceived);
  }
}
</script>

<style>
.card {
  border-radius: 3px;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.21);
  background-color: transparent;
}
</style>
